<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="11"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Create Specialty</h1>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="11"
                align="center"
                justify="center"
            >
                <ProfessionEditForm />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ProfessionEditForm from './ProfessionEditForm';
import Overlay from '../../../../components/Overlay';

export default {
    components: { Overlay, ProfessionEditForm }
};
</script>
